/* eslint-disable */
<template>
  <div id="simple-dash">
    <!--Class Picker-->
    <div
      v-if="simpleDashType === 'classpicker'"
      id="class-picker"
    >
      <v-container v-if="!classPicker.loaded" class="loader">
        <v-progress-circular indeterminate size="70" :width="5"></v-progress-circular>
      </v-container>
      <div id="card" v-if="classPicker.loaded">
        <v-list class="branded-background">
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <v-icon color="white">folder_shared</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>
                <span class="text-white text-truncate-popover">Select a Class</span>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>
        <v-card style="margin-top:20px;" elevation="0">
          <el-table
            :data="classPicker.data"
            height="400px"
            :row-class-name="classpickerTableClass"
            :show-header="false"
          >
            <el-table-column prop="name" width="350" label="Class Name"> </el-table-column>
            <el-table-column prop="" width="200" align="center" label="Join">
              <template slot-scope="scope">
                <v-btn
                  v-if="scope.row.timestamp"
                  class="branded-background text-white"
                  @click="joinRedirect(scope.row.id)"
                  >Launch</v-btn
                >
                <v-btn v-if="!scope.row.timestamp" flat text class="branded-text" @click="joinRedirect(scope.row.id)"
                  >Join</v-btn
                >
              </template>
            </el-table-column>
            <template slot="empty">
              <h1>No Classes Found</h1>
            </template>
          </el-table>
        </v-card>
      </div>
    </div>

    <!--Student Activate-->
    <div
      v-if="simpleDashType === 'studentactivate'"
      id="student-activate"
    >
      <v-card id="card" elevation="0">
        <v-list class="branded-background">
          <v-list-tile avatar>
            <img src="//cdn.playposit.com/images/dog_white.png" alt="avatar" width="40px" style="margin-right:36px;" />
            <v-list-tile-content>
              <v-list-tile-title>
                <h3 class="text-white">Reactivate Student Account</h3>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>
        <v-card elevation="0">
          <div style="padding:20px;">
            <v-list three-line style="background-color: #fafafa;">
              <v-list-tile>
                <v-list-tile-content>
                  <h3>Your account for {{ learnerData.email }} has been deactivated.</h3>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile class="column">
                <v-btn class="branded-background text-white" @click="reactivate">Reactivate Student Account</v-btn>
              </v-list-tile>
              <v-list-tile class="column">
                <v-btn flat text class="branded-grey" @click="signup">Create New Account</v-btn>
              </v-list-tile>
            </v-list>
          </div>
        </v-card>
      </v-card>
    </div>

    <LTIGreyScreen />

    <!--LMB grey screen -->
    <div
      id="lti-loader"
      v-if="(
        simpleDashType === 'lmb'
        && !userDataLoaded
      )"
    >
      <v-progress-circular color="white" indeterminate size="70" :width="5"> </v-progress-circular>
    </div>

    <!-- student LMB grey screen -->
    <div
      id="lti"
      v-if="(
        simpleDashType === 'lmb'
        && userDataLoaded
      )"
    >
      <h1 id="lti-title">{{ lmbData.title }}</h1>
      <p id="lti-msg">{{ lmbData.learning_objective }}</p>
      <div id="lmb-actions">
        <!-- LMB not started yet -->
        <v-btn
          v-if="!lmbData.bulbAttemptId"
          id="lmb-primary"
          class="primary text--white"
          @click="lmbLaunch"
          :loading="learnersAjaxing"
          aria-label="Press Enter to start assignment"
        >
          Start
        </v-btn>
        <!-- LMB not yet submitted -->
        <!-- [ ] make aria dynamic -->
        <!-- new peer review grading flow from this task: https://playposit.atlassian.net/browse/PP-415 -->
        <v-btn
          v-else-if="(
            peerReviewGradingEnabled
            && !lmbData.complete_date
            && !lmbData.completion_time
          )"
          id="lmb-primary"
          class="primary text--white"
          @click="lmbLaunch"
          :loading="learnersAjaxing"
          aria-label="Press Enter to edit assignment"
        >
          {{ _.get(this.lmbData, 'config.lmb.peer_review') ? 'Edit Peer Review Submission' : 'Edit Submission' }}
        </v-btn>
        <!-- LMB not yet submitted -->
        <!-- [ ] make aria dynamic -->
        <!-- 'original' peer review and lmb flow -->
        <v-btn
          v-else-if="!peerReviewGradingEnabled && lmbData.bulbAttemptId && !lmbData.complete"
          id="lmb-primary"
          class="primary text--white"
          @click="lmbLaunch"
          :loading="learnersAjaxing"
          aria-label="Press Enter to edit assignment"
        >
          {{ _.get(this.lmbData, 'config.lmb.peer_review') ? 'Edit Peer Review Submission' : 'Edit Submission' }}
        </v-btn>
        <!-- LMB submitted -->
        <v-btn
          v-else
          id="lmb-secondary"
          @click="lmbLaunch"
          :loading="learnersAjaxing"
          aria-label="Press Enter to preview submission"
        >
          <span class="branded-text">Preview Submission</span>
        </v-btn>
        <span
          v-if="lmbData.complete || (peerReviewGradingEnabled && (lmbData.complete_date || lmbData.completion_time))"
          style="color: #fff; padding-left: 24px; font-size: 16px;"
        >
          Submitted on {{ lmbSubmitted }}
        </span>
        <span
          v-if="lmbData.complete || (peerReviewGradingEnabled && (lmbData.complete_date || lmbData.completion_time))"
          style="color: #fff; padding-left: 24px; font-size: 16px;"
        >
          Score: {{ lmbScore }}
        </span>
      </div>

      <!--Peer Review Tables-->
      <div
        v-if="(
          peerReviewComplete
          || (
            peerReviewGradingEnabled
            && (
              lmbData.complete_date
              || lmbData.completion_time
            )
          )
        )"
        class="lmb-peer-review"
      >
        <v-tabs grow v-model="lmbtab">
          <v-tab key="0" href="#">
            Give Feedback
          </v-tab>
          <v-tab key="1" href="#">
            View Feedback
          </v-tab>
          <v-tab key="2" href="#">
            Instructor Feedback
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="lmbtab">
          <!-- Give Peers Feedback -->
          <v-tab-item class="tab-overflow">
            <div class="lmb-table give-feedback-table">
              <el-table :data="peerReview.give" height="250px">
                <el-table-column prop="thumbnail" label="" align="center" width="80">
                  <template slot-scope="scope">
                    <div class="column" style="height:50px;">
                      <v-responsive
                        :aspect-ratio="16 / 9"
                        height="36px"
                        width="64px"
                        max-height="36px"
                        max-width="64px"
                      >
                        <div class="thumbnail-wrapper-nonselect" :style="thumbnailStyle(scope.row.thumbnail)"></div>
                      </v-responsive>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column align="left" prop="student_name" label="Learner">
                  <template slot="header" slot-scope="scope">
                    <div>Learner</div>
                  </template>
                  <template slot-scope="scope">
                    <span
                      class="selectable"
                      v-if="scope.row.lmb_id != null"
                      @click="playLMB(scope.row.lmb_id, scope.row.lmb_section_id)"
                      @keyup.enter="playLMB(scope.row.lmb_id, scope.row.lmb_section_id)"
                      tabindex="0"
                      :aria-label="
                        'Give feedback for ' +
                          scope.row.student_name +
                          ' status: ' +
                          scope.row.status +
                          ' points ' +
                          scope.row.points +
                          ' score: ' +
                          scope.row.score +
                          '. Press Enter to launch Learner Made Bulb.'
                      "
                      >{{ scope.row.student_name }}</span
                    >
                    <span
                      v-if="scope.row.lmb_id === null"
                      tabindex="0"
                      :aria-label="scope.row.student_name + ' ' + scope.row.status"
                      >{{ scope.row.student_name }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="points" width="75" label="Points">
                  <template slot="header" slot-scope="scope">
                    <div>Points</div>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="score" width="75" label="Score">
                  <template slot="header" slot-scope="scope">
                    <div>Score</div>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="status" width="300" label="Status">
                  <template slot="header" slot-scope="scope">
                    <div>Status</div>
                  </template>
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.lmb_id === null" type="info">{{ scope.row.status }}</el-tag>
                    <el-tag
                      v-if="!scope.row.complete && scope.row.complete != 0 && scope.row.lmb_id != null"
                      type="danger"
                      >{{ scope.row.status }}</el-tag
                    >
                    <el-tag v-if="scope.row.complete === 0" type="warning">{{ scope.row.status }}</el-tag>
                    <el-tag v-if="scope.row.complete === 1" type="success">{{ scope.row.status }}</el-tag>
                  </template>
                </el-table-column>
                <template slot="empty">
                  <span>No other learners in group</span>
                </template>
              </el-table>
            </div>
            <v-btn
              class="branded-text branded-outline"
              aria-label="Refresh Peer Submissions"
              color="#fff"
              style="margin-top: 12px;"
              @click="refreshLmb('assignments')"
            >
              <v-icon class="branded-text">refresh</v-icon>
              <span class="branded-text">Refresh Data</span>
            </v-btn>
          </v-tab-item>
          <!--Peer Student Feedback-->
          <v-tab-item class="tab-overflow">
            <div class="lmb-table">
              <el-table :data="peerReview.view" height="250px">
                <el-table-column align="left" prop="student_name" label="Learner">
                  <template slot="header" slot-scope="scope">
                    <div>Learner</div>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="score" width="75" label="Score">
                  <template slot="header" slot-scope="scope">
                    <div>Score</div>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="status" width="300" label="Status">
                  <template slot="header" slot-scope="scope">
                    <div>Status</div>
                  </template>
                  <template slot-scope="scope">
                    <span
                      tabindex="0"
                      :aria-label="
                        'View Feedback ' +
                          scope.row.student_name +
                          ' Status: ' +
                          scope.row.status +
                          ' Score: ' +
                          scope.row.score
                      "
                    >
                    </span>
                    <el-tag v-if="!scope.row.complete && scope.row.complete != 0" type="info">{{
                      scope.row.status
                    }}</el-tag>
                    <el-tag v-if="scope.row.complete === 0" type="warning">{{ scope.row.status }}</el-tag>
                    <el-tag v-if="scope.row.complete === 1" type="success">{{ scope.row.status }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop=""
                  :width="lmbData.config.lmb.pr_rubric ? '75' : '5'"
                  label="Rubric"
                >
                  <template slot-scope="scope">
                    <el-popover
                      trigger="click"
                      placement="left"
                      width="450"
                      v-if="lmbData.config.lmb.pr_rubric"
                      :disabled="scope.row.bulbattempt_id === null || !scope.row.complete"
                      v-model="menus.receivedFeedbackRubric[scope.row.id]"
                    >
                      <!-- Peer Feedback Rubric Activator -->
                      <v-btn
                        slot="reference"
                        :aria-label="'Rubric from ' + scope.row.student_name"
                        :disabled="scope.row.bulbattempt_id === null || !scope.row.complete"
                        flat
                        icon
                      >
                        <v-icon class="branded-text">dns</v-icon>
                      </v-btn>
                      <!-- Peer Feedback Rubric Content -->
                      <div
                        style="width:450px; height: 400px; overflow:scroll;"
                        v-if="menuData.receivedFeedbackRubric[scope.row.id]"
                        aria-live="polite"
                      >
                        <h1 class="headline primary white--text interaction-review-title py-3 px-2 mb-3 text-xs-center">
                          Rubric View
                        </h1>
                        <PlaypositInteraction
                          v-for="rubricInteraction in finalizedRubricInteractions"
                          :key="rubricInteraction.id"
                          :bulb-id="parseInt(lmbData.lmb_id, 10)"
                          :section-id="parseInt(lmbData.lmb_section_id, 10)"
                          :student-id="parseInt(scope.row.id, 10)"
                          :interactionId="parseInt(rubricInteraction.id, 10)"
                          :token="instructorData.token"
                          :restrict-discussion-comments-by-student-id="scope.row.id"
                          user-type="teacher"
                          discussion-role="observer"
                          perspective="answered"
                        />
                      </div>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="" width="150">
                  <template slot="header" slot-scope="scope">Discussion</template>
                  <template slot-scope="scope">
                    <el-popover
                      trigger="click"
                      placement="left"
                      width="300"
                      :disabled="scope.row.bulbattempt_id === null"
                      v-model="menus.receivedFeedbackDiscussion[scope.row.id]"
                    >
                      <!-- Peer Feedback Chat Activator -->
                      <v-btn
                        slot="reference"
                        :aria-label="'Press enter to view feedback discussion for student ' + scope.row.student_name"
                        depressed
                        :disabled="scope.row.bulbattempt_id === null"
                      >
                        <v-icon style="font-size: 16px;">chat</v-icon>
                      </v-btn>
                      <!-- Peer Feedback Chat Content -->
                      <template v-if="menuData.receivedFeedbackDiscussion[scope.row.id]" aria-live="polite">
                        <div class="question_header">
                          <v-icon color="white">chat</v-icon>
                          <span>00:00:00</span>
                        </div>
                        <div>
                          <PlaypositInteraction
                            :anonymous="lmbData.config.lmb.pr_anonymous"
                            :bulb-id="parseInt(peerReviewBulbId, 10)"
                            :section-id="parseInt(lmbData.lmb_section_id, 10)"
                            :student-id="parseInt(scope.row.id, 10)"
                            :interactionId="parseInt(peerReview.discussion.id, 10)"
                            :token="instructorData.token"
                            :restrict-discussion-comments-by-student-id="scope.row.id"
                            user-type="teacher"
                            discussion-role="observer"
                            perspective="answered"
                          />
                        </div>
                      </template>
                    </el-popover>
                  </template>
                </el-table-column>
                <template slot="empty">
                  <span>No other learners in group</span>
                </template>
              </el-table>
            </div>
            <v-btn
              class="branded-text branded-outline"
              aria-label="Refresh Peer Feedback"
              color="#fff"
              style="margin-top: 12px;"
              @click="refreshLmb('feedback')"
            >
              <v-icon class="branded-text">refresh</v-icon>
              <span class="branded-text">Refresh Data</span>
            </v-btn>
          </v-tab-item>
          <!--Instructor Feedback -->
          <v-tab-item class="tab-overflow">
            <div class="lmb-table">
              <el-table :data="peerReview.instructor" height="250px">
                <el-table-column align="left" prop="teacher_name" label="Instructor">
                  <template
                    slot="header"
                    slot-scope="scope"
                  >
                    <div>Instructor</div>
                  </template>
                </el-table-column>
                <!-- Instructor status of feedback: -->
                <el-table-column
                  align="center"
                  prop="status"
                  width="300"
                  label="Status"
                >
                  <template slot="header" slot-scope="scope">
                    <div>Status</div>
                  </template>
                  <template slot-scope="scope">
                    <span
                      tabindex="0"
                      :aria-label="
                        'View Instructor Feedback ' +
                          scope.row.teacher_name +
                          ' Status: ' +
                          scope.row.status +
                          ' Score: ' +
                          scope.row.score
                      "
                    ></span>
                    <el-tag
                      v-if="!scope.row.complete && scope.row.complete != 0"
                      type="info"
                      :aria-label="scope.row.status"
                      >{{ scope.row.status }}</el-tag
                    >
                    <el-tag v-if="scope.row.complete === 0" type="warning" :aria-label="scope.row.status">{{
                      scope.row.status
                    }}</el-tag>
                    <el-tag v-if="scope.row.complete === 1" type="success" :aria-label="scope.row.status">{{
                      scope.row.status
                    }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop=""
                  :width="lmbData.config.lmb.pr_rubric ? '75' : '5'"
                  :label="lmbData.config.lmb.pr_rubric ? 'Rubric' : ''"
                >
                  <template slot-scope="scope">
                    <el-popover
                      v-model="menus.instructorFeedbackRubric[scope.row.id]"
                      trigger="click"
                      placement="left"
                      width="450"
                    >
                      <!-- Instructor Feedback Rubric Activator -->
                      <v-btn
                        slot="reference"
                        :aria-label="'Rubric from ' + scope.row.teacher_name"
                        :disabled="(
                          scope.row.bulbattempt_id === null
                          || !scope.row.complete
                        )"
                        flat
                        icon
                      >
                        <v-icon class="branded-text">dns</v-icon>
                      </v-btn>
                      <!-- Instructor Feedback Rubric Content -->
                      <div
                        v-if="(
                          menuData.instructorFeedbackRubric[scope.row.id]
                          && scope.row.bulbattempt_id !== null
                        )"
                        aria-live="polite"
                      >
                        <h1
                          class="headline primary white--text interaction-review-title py-3 px-2 mb-3 text-xs-center"
                        >
                          Rubric View
                        </h1>
                        <PlaypositInteraction
                          v-for="rubricInteraction in finalizedRubricInteractions"
                          :key="rubricInteraction.id"
                          :bulb-id="parseInt(lmbData.lmb_id, 10)"
                          :section-id="parseInt(lmbData.lmb_section_id, 10)"
                          :student-id="parseInt(scope.row.id, 10)"
                          :interactionId="parseInt(rubricInteraction.id, 10)"
                          :token="instructorData.token"
                          :restrict-discussion-comments-by-student-id="scope.row.id"
                          user-type="teacher"
                          discussion-role="observer"
                          perspective="answered"
                        />
                      </div>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop=""
                  width="150"
                >
                  <!-- Instructor Feedback Chat Column Header -->
                  <template
                    v-if="lmbData.config.lmb.pr_rubric"
                    slot="header"
                    slot-scope="scope"
                  >
                    Discussion
                  </template>
                  <template slot-scope="scope">
                    <el-popover
                      v-if="lmbData.config.lmb.pr_rubric"
                      trigger="click"
                      placement="left"
                      width="300"
                      :disabled="scope.row.bulbattempt_id === null"
                      v-model="menus.instructorFeedbackDiscussion[scope.row.id]"
                    >
                      <!-- Instructor Feedback Chat Activator -->
                      <v-btn
                        slot="reference"
                        v-if="lmbData.config.lmb.pr_rubric"
                        depressed
                        :disabled="scope.row.bulbattempt_id === null"
                        :aria-label="'Feed Discussion Comments from ' + scope.row.teacher_name"
                      >
                        <v-icon style="font-size: 16px;">chat</v-icon>
                      </v-btn>
                      <!-- Instructor Feedback Chat Content -->
                      <div
                        class="popover-content-wrapper"
                        v-if="menuData.instructorFeedbackDiscussion[scope.row.id]"
                        aria-live="polite"
                      >
                        <div class="question_header" aria-label="Discussion Comments">
                          <v-icon color="white">chat</v-icon>
                          <span>00:00:00</span>
                        </div>
                        <PlaypositInteraction
                          :bulb-id="parseInt(peerReviewBulbId, 10)"
                          :section-id="parseInt(lmbData.lmb_section_id, 10)"
                          :student-id="parseInt(scope.row.id, 10)"
                          :interactionId="parseInt(peerReview.discussion.id, 10)"
                          :token="instructorData.token"
                          :restrict-discussion-comments-by-student-id="scope.row.id"
                          user-type="teacher"
                          discussion-role="observer"
                          perspective="answered"
                        />
                      </div>
                    </el-popover>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <v-btn
              class="branded-text branded-outline"
              aria-label="Refresh Instructor Feedback"
              color="#fff"
              style="margin-top: 12px;"
              @click="refreshLmb('feedback')"
            >
              <v-icon class="branded-text">refresh</v-icon>
              <span class="branded-text">Refresh Data</span>
            </v-btn>
          </v-tab-item>
        </v-tabs-items>
      </div>

    </div>

  </div>
</template>

<script>
// Components
import Discussion from './Discussion';
import LTIGreyScreen from './LTIGreyScreen.vue';

// Plugins / Libraries
import _ from 'lodash';
import moment from 'moment';
import { BroadcastChannel, } from 'broadcast-channel';
import {
  PlayPositBroadcastChannels,
  PlayPositBroadcastChannelEventNames,
} from '@BroadcastChannels';

import {
  mapState,
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex';

export default {
  name: 'simple-dash',
  components: {
    Discussion,
    LTIGreyScreen,
  },
  data() {
    return {
      blueScreenData: {},
      simpleDashBroadcastChannel: null,
      lmbData: {},
      lmbtab: 0,
      interaction_review_options: {},
      menus: {
        instructorFeedbackRubric: {},
        instructorFeedbackDiscussion: {},
        receivedFeedbackRubric: {},
        receivedFeedbackDiscussion: {},
      },
      menuData: {
        instructorFeedbackRubric: {},
        instructorFeedbackDiscussion: {},
        receivedFeedbackRubric: {},
        receivedFeedbackDiscussion: {},
      },
      updatedPeerReviewScore: null,
    };
  },
  computed: {
    ...mapState([
      'lti13Launch',
    ]),
    ...mapGetters([
      'serverURL',
      'nodeApiPrefix',
      'simpleDash',
      'simpleDashType',
      'simpleDashData',
      'simpleDashLoading',
      'simpleDashReload',
      'learnerData',
      'instructorData',
      'designerApiPrefix',
      'playerApiPrefix',
      'LMSdata',
      'LTIclassName',
      'LTIdata',
      'LTIlaunch',
      'popoverToggles',
      'userDataLoaded',
      'phpApiPrefix',
      'school',
      'primaryAccount',
      'hasCanvasApi',
    ]),
    ...mapGetters('admin', ['schoolsWithChangedDefaultView']),
    ...mapGetters('instructors', ['playlistHash', 'hasCustomLtiDash']),
    ...mapGetters('learners', ['classPicker', 'learnersAjaxing', 'peerReview']),
    peerReviewComplete() {
      return (
        _.get(this, 'lmbData.config.lmb.peer_review')
        && _.get(this, 'lmbData.complete')
      );
    },
    isPeerReview() {
      return _.get(this, 'lmbData.config.lmb.peer_review');
    },
    peerReviewGradingEnabled() {
      return (
        _.get(this, 'lmbData.config.lmb.peer_review', false)
        && _.get(this, 'lmbData.config.lmb.grade', false)
      );
    },
    //Blue Screen Computed
    titleColor: function() {
      if (this.blueScreenData.titleColor) {
        return this.blueScreenData.titleColor;
      } else {
        return '#FFF';
      }
    },
    titleColorStyle: function() {
      if (this.blueScreenData.titleColor) {
        return `color: ${this.blueScreenData.titleColor};`;
      } else {
        return 'color: #FFF';
      }
    },
    iconSize: function() {
      let width = window.innerWidth;

      if (width > 780) {
        return 56;
      } else if (width <= 780 && width >= 400) {
        return 46;
      } else {
        return 36;
      }
    },
    lmbScore() {
      if (this.peerReviewGradingEnabled) {
        if (this.userHasProvidedFeedbackForAllStudents()) {
          const [pointsEarned, pointsAvailable] = [
            this.lmbData?.points_earned ?? this.updatedPeerReviewScore?.pointsEarned,
            this.lmbData?.points_available ?? this.updatedPeerReviewScore?.pointsAvailable,
          ];
          return `${Math.round((pointsEarned / pointsAvailable) * 100, 2)}%`;
        } else return '-%';
      }
      if (this.lmbData.bulbAttemptId && this.lmbData.points_earned !== null) {
        return `${Math.round((this.lmbData.points_earned / this.lmbData.points_available) * 100, 2)}%`;
      }
      return '-%';
    },
    lmbSubmitted() {
      if (this.lmbData.bulbAttemptId && (this.lmbData.complete_date || this.lmbData.completion_time)) {
        const date = this.lmbData.complete_date || this.lmbData.completion_time;
        return moment(date).format('MMM DD, YYYY');
      }
      return 'Pending';
    },
    finalizedRubricInteractions() {
      return _(_.get(this, 'peerReview.interactions', []))
        .filter(interaction => interaction.interactionType !== 'discussion_q')
        .orderBy('displayInTime', 'ASC')
        .value();
    },
    peerReviewBulbId() {
      return _.get(this, 'peerReview.interactions[0].bulbId');
    },
  },
  methods: {
    ...mapActions('learners', [
      'updateStudentLMBBulbAttemptCompletion',
    ]),
    ...mapMutations([
      'handleDialogOpen',
      'setDashModal',
      'simpleDashToggle',
      'slideOut',
    ]),
    getData: function() {
      if (this.simpleDashType === 'classpicker') {
        const params = this.$route.params;
        const query = this.$route.query;
        this.$store.dispatch('learners/getClassPicker', [
          params.bulb_id,
          params.teacher_id,
          query.token,
        ]);
      }

      if (this.simpleDashType === 'lmb') {
        this.lmbData = this.simpleDashData;
        if (
          this.peerReviewComplete
          || (
            this.peerReviewGradingEnabled
            && (
              this.lmbData.complete_date
              || this.lmbData.completion_time
            )
          )
        ) {
          this.loadLMBPeerReview();
        }
      }
    },

    //Class Picker Functions
    joinRedirect: function(id) {
      let params = this.$route.params;
      let query = this.$route.query;
      window.location.replace(
        `${this.nodeApiPrefix}/authnew/e/${query.type}/${params.bulb_id}/${params.teacher_id}/${id}/?token=${query.token}`
      );
    },
    classpickerTableClass: function() {
      //assign class table has no borders
      return 'no-border padding-left row-height-large';
    },

    //Student Activate Functions
    reactivate: function() {
      //dispatches reactivation function
      this.$store.dispatch('learners/reactivateAccount');
    },
    signup: function() {
      //opens up signup page
      window.location.replace(`${this.phpApiPrefix}/join`);
    },
    loadLMBPeerReview() {
      this.$store.dispatch('learners/getPeerReviewAssignments', {
        bulb_id: this.lmbData.root_id,
        section_id: this.lmbData.section_id,
        student_id: this.learnerData.id,
        ...(this.peerReviewGradingEnabled && { peerReviewGrading: true }),
      });
      this.$store.dispatch('learners/getPeerReviewFeedback', {
        anonymous: this.lmbData.config.lmb.pr_anonymous,
        bulb_id: this.lmbData.root_id,
        lmb_id: this.lmbData.lmb_id,
        lmb_section_id: this.lmbData.lmb_section_id,
        rubric: this.lmbData.config.lmb.pr_rubric,
        section_id: this.lmbData.section_id,
        student_id: this.learnerData.id,
        inCanvasLMS: this.lmbData.resource_link_id?.includes('canvas'),
      });
    },
    /**
     * This method takes care of three flows:
     *
     * 1) Initial creation of an [Peer Review] LMB bulb
     * 2) Editing a [Peer Review] LMB bulb
     * 3) Playing the created [Peer Review] LMB bulb in the player.
     */
    lmbLaunch: function() { // this shit is the worst...
      const issuer = this?.$route?.query?.issuer ?? this?.LTIdata?.issuer;
      if (!this.lmbData.bulbAttemptId)
        return this.$store.dispatch('learners/createLMB', {
          id: this.lmbData.root_id,
          section_id: this.lmbData.section_id,
          resource_link_id: this.lmbData.resource_link_id,
          issuer,
          lti13Launch: this.lti13Launch,
        });
      if (this.peerReviewGradingEnabled) {
        // wonky logic, i know but this basically comes down to how our LMB flow is inherently structured.
        if (this.lmbData?.complete_date || this.lmbData?.completion_time) {
          return window.open(
            `${this.playerApiPrefix}/player_v2/?type=share&bulb_id=${this.lmbData.lmb_id}&token=${this.instructorData.token}&section_id=${this.lmbData.lmb_section_id}&lms_launch=true${!!issuer ? `&issuer=${issuer}` : ''}${this.lti13Launch ? `&lti13Launch=${true}` : ''}`
          );
        } else
          return window.open(
            `${this.designerApiPrefix}/designer/?bulb_id=${this.lmbData.lmb_id}&section_id=${this.lmbData.section_id}&token=${this.instructorData.token}${!!issuer ? `&issuer=${issuer}` : ''}${this.lti13Launch ? `&lti13Launch=${true}` : ''}`
          );
      }
      if (!this.lmbData.complete) {
        return window.open(
          `${this.designerApiPrefix}/designer/?bulb_id=${this.lmbData.lmb_id}&section_id=${this.lmbData.section_id}&token=${this.instructorData.token}${!!issuer ? `&issuer=${issuer}` : ''}${this.lti13Launch ? `&lti13Launch=${true}` : ''}`
        );
      }
      return window.open(
        `${this.playerApiPrefix}/player_v2/?type=share&bulb_id=${this.lmbData.lmb_id}&token=${this.instructorData.token}&section_id=${this.lmbData.lmb_section_id}&lms_launch=true${!!issuer ? `&issuer=${issuer}` : ''}${this.lti13Launch ? `&lti13Launch=${true}` : ''}`
      );
    },
    async manageGroups() {
      // load classes so instructorDynamicToolbar Learners tab can correctly get selectedClass data
      await this.$store.dispatch('instructors/getClasses');
      // set activeView so the Vue Router can render the general "Classes" page
      this.$store.commit('setNav', ['Classes', 'instructor']);
      // set queryParams so we can render the correct section
      let queryParams = {
        bulb_id: this.LTIdata.contentId,
        contentId: this.LTIdata.contentId,
        section_id: this.LTIdata.section_id,
        lms_class: true,
      };
      this.$store.commit('instructors/setQueryParams', queryParams);
      // set instructorActiveView for the specific "Learners" tab inside of class view
      this.$store.commit('instructors/setActiveView', ['Learners']);
      // udadate what is rendered in the Toolbar Breadcrumbs area
      this.$store.commit('updateBreadCrumbs', [
        [
          {
            text: 'Classes',
            disabled: false,
            payload: 'Classes',
          },
          {
            text: this.LTIclassName,
            payload: '',
          },
        ],
        {},
      ]);
      // load learners to populate the table behind the groups slideout
      this.$store.dispatch('instructors/getTableData');
      this.$store.dispatch('instructors/updateUrl');
      this.$store.commit('simpleDashToggle', { activate: false }); // close the grey screen
      this.slideOut({
        toggle: true,
        view: 'groups',
        sectionId: this.LTIdata.section_id,
        initialTab: this.hasCanvasApi && this.LMSdata.type === 'Canvas' ? 1 : 0,
      }); // open groups slideout
    },
    playLMB: function(bulb_id, section_id) {
      window.open(
        `${this.playerApiPrefix}/player_v2/?section_id=${section_id}&type=bulb&bulb_id=${bulb_id}&token=${this.learnerData.token}&lms_launch=true`
      );
    },
    thumbnailStyle: function(url) {
      return {
        backgroundImage: `url("${url}")`,
      };
    },
    refreshLmb: function(type) {
      if (type === 'assignments') {
        this.$store.dispatch('learners/getPeerReviewAssignments', {
          bulb_id: this.lmbData.root_id,
          section_id: this.lmbData.section_id,
          student_id: this.learnerData.id,
          notification: true,
          ...(this.peerReviewGradingEnabled && { peerReviewGrading: true }),
        });
      } else {
        this.$store.dispatch('learners/getPeerReviewFeedback', {
          anonymous: this.lmbData.config.lmb.pr_anonymous,
          bulb_id: this.lmbData.root_id,
          lmb_id: this.lmbData.lmb_id,
          lmb_section_id: this.lmbData.lmb_section_id,
          rubric: this.lmbData.config.lmb.pr_rubric,
          section_id: this.lmbData.section_id,
          student_id: this.learnerData.id,
          notification: true,
        });
      }
    },
    initializeSimpleDashBroadcastChannel() {
      this.simpleDashBroadcastChannel = new BroadcastChannel(PlayPositBroadcastChannels.bulbControlsBroadcastChannel);
      this.listenForBroadcastChannelEvents();
    },
    userHasProvidedFeedbackForAllStudents() {
      return this.peerReview.give.every(
        givenFeedback => givenFeedback.complete && givenFeedback.status.toLowerCase().includes('completed on')
      );
    },
    listenForBroadcastChannelEvents() {
      this.simpleDashBroadcastChannel.onmessage = event => {
        if (event === PlayPositBroadcastChannelEventNames.PEER_REVIEW_STUDENT_FEEDBACK_GIVEN) {
          // Order for refreshing the data is important and matters here:
          this.refreshLmb('assignments');
          this.refreshLmb('feedback');
        }
      };
    },
  },
  watch: {
    simpleDashReload: {
      handler: function(val) {
        if (val) {
          this.lmbData = this.simpleDashData;
          this.$store.commit('simpleDashReloadToggle', false);
          if (
            this.peerReviewComplete ||
            (this.peerReviewGradingEnabled && (this.lmbData.complete_date || this.lmbData.completion_time))
          ) {
            this.loadLMBPeerReview();
          }
        }
      },
    },
    menus: {
      handler(n, o) {
        for (const key in n) {
          for (const innerKey in n[key]) {
            if (n[key][innerKey]) {
              this.menuData[key][innerKey] = true;
            }
          }
        }
      },
      deep: true,
    },
    async 'peerReview.give'(n, o) {
      if (n) {
        if (!this.peerReviewGradingEnabled) return;
        if (this.userHasProvidedFeedbackForAllStudents()) {
          this.updatedPeerReviewScore = await this.updateStudentLMBBulbAttemptCompletion(1);
        } else {
          this.updateStudentLMBBulbAttemptCompletion(0);
        }
      }
    },
  },
  mounted() {
    // Setting up namespaced debugging object for our SimpleDash Vue component
    window.PP.SimpleDash = {
      vm: this,
    };

    if (document.getElementById('beacon-container')) {
      document.getElementById('beacon-container').style.display = 'none';
    }
    
    this.getData();
    this.initializeSimpleDashBroadcastChannel();
  },
  async beforeDestroy() {
    await this.simpleDashBroadcastChannel.close();
  },
};
</script>

<style scoped>
#simple-dash {
  width: 100vw;
  height: 100vh;
  z-index: 1111;
}

.theme--light.v-btn.v-btn--disabled i {
  color: #4d4d4d !important;
}

.cell,
.cell div,
.cell span {
  color: #4d4d4d;
}

/*class picker css*/
#class-picker {
  width: 100vw;
  height: 100vh;
  background-color: #f1f1f1;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  overflow: auto;
}

#card {
  width: 550px;
  height: 450px;
  background-color: white;
}

/*student activate css*/
#student-activate {
  width: 100vw;
  height: 100vh;
  background-color: #858585;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

#card {
  width: 50vw;
  height: 70vh;
}

/*lmb classes*/
#lmb-actions {
  width: 100%;
  height: 100px;
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;
}

#lmb-primary {
  /*background-color: var(--branding-active-hex) !important;*/
  /*color: #fff;*/
  font-size: 1.3rem;
  height: 42px;
  min-width: 170px;
}

.lmb-peer-review {
  width: 100%;
  padding: 0px 24px;
  height: 400px;
}
.lmb-peer-review .v-tabs {
  width: 100%;
}

.lmb-peer-review .v-tabs__div {
  color: #fff !important;
  font-size: 18px;
}

.lmb-table {
  margin-top: 24px;
  width: 100%;
  height: 250px;
  background-color: #fff;
}

.tab-overflow {
  overflow: visible !important;
  min-height: 350px;
}

/*blue screen css*/
#bluescreen {
  width: 100vw;
  height: 100vh;
  padding: 10px 24px;
  background-color: #2196f3;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

#title {
  width: 100%;
  height: 150px;
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;
  padding: 48px;
}

#title h1 {
  font-size: 3rem;
  margin-left: 24px;
}

#msg {
  width: 100%;
  height: 100px;
  padding: 12px;
  font-size: 2rem;
  color: #fff;
}

#submsg {
  width: 100%;
  height: 150px;
  padding: 12px;
  font-size: 1.5rem;
  color: #fff;
}

#actions {
  width: 100%;
  height: 100px;
  padding: 12px;
  display: flex;
  flex-flow: row;
  justify-content: space-around;
  align-items: center;
}

#primary {
  background-color: #fff;
  color: #2196f3;
}

#secondary {
  background-color: #2196f3;
  color: #fff;
}

@media only screen and (max-width: 400px) and (orientation: portrait) {
  /* For mobile: */
  #title {
    width: 100%;
    height: 100px;
    padding: 16px;
    margin-top: 24px;
  }

  #title h1 {
    font-size: 1.5rem;
    margin-left: 16px;
  }

  #msg {
    padding: 4px 16px;
    font-size: 1.2rem;
  }

  #submsg {
    padding: 4px 16px;
    font-size: 0.9rem;
  }

  #actions {
    height: 100px;
    padding: 16px;
  }

  #lti-title {
    padding: 8px 12px;
    font-size: 1.7rem;
  }

  #lti-msg,
  #lti-msu-msg {
    padding: 8px 12px;
    font-size: 1rem;
    font-weight: bold;
  }

  .lmb-peer-review .v-tabs__div {
    font-size: 14px;
  }

  .el-table__header-wrapper {
    padding-top: 10px;
  }

  #lmb-primary {
    font-size: 14px;
    font-weight: bold;
  }

  #lti-primary span {
    font-size: 14px;
    font-weight: bold;
  }

  #lti-secondary span,
  #lti-tertiary span {
    font-size: 14px;
    font-weight: bold;
  }

  #lti-exit {
    font-size: 14px;
    font-weight: bold;
  }
}

@media only screen and (max-width: 400px) and (orientation: landscape) {
  /* For mobile: */
  #title {
    width: 100%;
    height: 100px;
    padding: 16px;
    margin-top: 10px;
  }

  #title h1 {
    font-size: 1.5rem;
    margin-left: 16px;
  }

  #msg {
    padding: 4px 16px;
    font-size: 1.2rem;
  }

  #submsg {
    padding: 4px 16px;
    font-size: 0.9rem;
  }

  #actions {
    height: 100px;
    padding: 16px;
  }

  #lti-title {
    padding: 8px 12px;
    font-size: 1.7rem;
  }

  #lti-msg,
  #lti-msu-msg {
    padding: 8px 12px;
    font-size: 1rem;
    font-weight: bold;
  }

  .lmb-peer-review .v-tabs__div {
    font-size: 14px;
  }

  #lmb-primary {
    font-size: 14px;
    font-weight: bold;
  }

  #lti-primary span {
    font-size: 14px;
    font-weight: bold;
  }

  #lti-secondary span,
  #lti-tertiary span {
    font-size: 14px;
    font-weight: bold;
  }

  #lti-exit {
    font-size: 14px;
    font-weight: bold;
  }
}

@media only screen and (min-width: 401px) and (max-width: 800px) and (orientation: portrait) {
  /* For tablets: */

  #title {
    padding: 24px;
    margin-top: 12px;
  }

  #title h1 {
    font-size: 1.7rem;
    margin-left: 16px;
  }

  #msg {
    padding: 24px;
    font-size: 1.3rem;
  }

  #submsg {
    padding: 24px;
    font-size: 1rem;
  }

  #actions {
    height: 150px;
    padding: 24px;
  }

  #lti-title {
    padding: 8px 12px;
    font-size: 1.7rem;
  }

  #lti-msg,
  #lti-msu-msg {
    padding: 8px 12px;
    font-size: 1rem;
    font-weight: bold;
  }

  .lmb-peer-review .v-tabs__div {
    font-size: 14px;
  }

  #lmb-primary {
    font-size: 14px;
    font-weight: bold;
  }

  #lti-primary span {
    font-size: 14px;
    font-weight: bold;
  }

  #lti-secondary span,
  #lti-tertiary span {
    font-size: 14px;
    font-weight: bold;
  }

  #lti-exit {
    font-size: 14px;
    font-weight: bold;
  }
}

@media only screen and (min-width: 401px) and (max-width: 800px) and (orientation: landscape) {
  /* For tablets: */

  #title {
    padding: 24px;
    margin-top: 12px;
  }

  #title h1 {
    font-size: 1.7rem;
    margin-left: 16px;
  }

  #msg {
    padding: 12px;
    font-size: 1.3rem;
  }

  #submsg {
    padding: 12px;
    font-size: 1rem;
  }

  #actions {
    height: 150px;
    padding: 12px;
  }

  #lti-title {
    padding: 8px 12px;
    font-size: 1.7rem;
  }

  #lti-msg,
  #lti-msu-msg {
    padding: 8px 12px;
    font-size: 1rem;
    font-weight: bold;
  }

  .lmb-peer-review .v-tabs__div {
    font-size: 14px;
  }

  #lmb-primary {
    font-size: 14px;
    font-weight: bold;
  }

  #lti-primary span {
    font-size: 14px;
    font-weight: bold;
  }

  #lti-secondary span,
  #lti-tertiary span {
    font-size: 14px;
    font-weight: bold;
  }

  #lti-exit {
    font-size: 14px;
    font-weight: bold;
  }
}
</style>
